import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, Typography, Box, Chip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import api_service from '../../api/api_service';

const Header = () => {
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        const parseJwt = (token) => {
            try {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                return JSON.parse(jsonPayload);
            } catch (e) {
                return null;
            }
        };

        const decoded = parseJwt(token);
        if (!decoded || !decoded.exp) return;

        const updateTimer = () => {
            const now = Math.floor(Date.now() / 1000);
            const remaining = decoded.exp - now;
            setTimeLeft(remaining > 0 ? remaining : 0);
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (seconds) => {
        if (seconds === null) return '';
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? '0' : ''}${s}`;
    };

    const handleLogout = () => {
        api_service.logout();
        window.location.reload();
    };

    const getTimeColor = () => {
        if (timeLeft === null) return '#4ade80';
        if (timeLeft < 300) return '#f87171'; 
        if (timeLeft < 600) return '#fbbf24'; 
        return '#4ade80'; 
    };

    return (
        <AppBar 
            position="static" 
            elevation={0}
            sx={{ 
                zIndex: 1201,
                background: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            }}
        >
            <Toolbar 
                sx={{ 
                    position: 'relative',
                    minHeight: '70px',
                    px: { xs: 2, sm: 3, md: 4 },
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    gap: 2,
                    flex: '1 1 0',
                }}>
                    {timeLeft !== null && (
                        <Chip
                            icon={<AccessTimeIcon sx={{ fontSize: 18, color: 'white !important' }} />}
                            label={formatTime(timeLeft)}
                            sx={{
                                backgroundColor: getTimeColor(),
                                color: 'white',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                height: '36px',
                                borderRadius: '18px',
                                px: 1,
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.15)',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.25)',
                                },
                                '& .MuiChip-label': {
                                    px: 1.5,
                                }
                            }}
                        />
                    )}
                </Box>

                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'translateX(-50%) scale(1.05)',
                        }
                    }}
                >
                    <Box
                        sx={{
                            background: 'rgba(255, 255, 255, 0.15)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '16px',
                            padding: '8px 20px',
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.25)',
                        }}
                    >
                        <img 
                            src="/LOGO.png" 
                            alt="LIRA Logo" 
                            style={{ 
                                height: '45px',
                                filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
                            }} 
                        />
                    </Box>
                </Box>

                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flex: '1 1 0',
                }}>
                    <Button 
                        variant="contained"
                        startIcon={<LogoutIcon />} 
                        onClick={handleLogout}
                        sx={{ 
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            px: 3,
                            py: 1,
                            borderRadius: '12px',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.15)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.25)',
                            },
                            '&:active': {
                                transform: 'translateY(0)',
                            }
                        }}
                    >
                        Logout
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
